import { createSlice } from '@reduxjs/toolkit';
import {
  countries,
  provinces,
  cities,
  districts,
  postalCodes,
} from '~store/location/thunks';

export const { actions, reducer } = createSlice({
  name: 'location',
  initialState: {
    countries: [],
    provinces: [],
    cities: [],
    districts: [],
    postalCodes: [],
  },
  reducers: {
    resetLocation: (state, action) => {
      state[action.payload] = [];
    },
    addPostalCode: (state, action) => {
      const code = action.payload;
      if (!state.postalCodes.some((item) => item.name === code)) {
        state.postalCodes = [{ _id: code, name: code }, ...state.postalCodes];
      }
    },
  },
  extraReducers: {
    [countries.fulfilled]: (state, { payload }) => {
      state.countries = payload;
    },
    [provinces.fulfilled]: (state, { payload }) => {
      state.provinces = payload;
    },
    [cities.fulfilled]: (state, { payload }) => {
      state.cities = payload;
    },
    [districts.fulfilled]: (state, { payload }) => {
      state.districts = payload;
    },
    [postalCodes.fulfilled]: (state, { payload, meta }) => {
      state.postalCodes = payload;
    },
  },
});

export const { resetLocation, addPostalCode } = actions;
export default reducer;
